module.exports = __webpack_public_path__ + "img/bsmTag.ab121ee0.png";